import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title.tsx';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { INTERACTION_OPTIONS } from './constants';

const InteractionStyles = styled(OnboardingPage)``;

export const ScreenInteraction: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Interaction',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const interaction = form.watch('interaction');

  const handleChange = (
    option: OnbOptionType<LayoutDataType['interaction']>,
  ) => {
    userService.createOrUpdate({
      onboarding_data: {
        interaction: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  const handleBackStep = (): void => {
    wizard.goToStep('about_look');
  };

  return (
    <InteractionStyles>
      <OnboardingNavigation onBack={handleBackStep} />

      <IonContent>
        <OwnAiTitle>What kind of interactions do you enjoy?</OwnAiTitle>
        <OnboardingOptionsList>
          {INTERACTION_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={interaction === option.id}
              control={form.control}
              option={option}
              name="interaction"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`interaction-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </InteractionStyles>
  );
};
